module.exports = __webpack_public_path__ + "static/media/nationwide.08504ef1.svg";